import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const HomeReducer = createSlice({
	name: 'home',
	initialState: {
		success: false,
		error: null,
		loading: false,
		loginInfo: null,
		user: null,
		forgot: null,
		otp: null,
		reset: null,
		changepassword: null,
		lead: null,
		cust: null,
		feedback: null,
	},
	reducers: {
		loginRequest(state, action) {
			state.loading = true;
		},
		loginSuccess(state, action) {
			state.loading = false;
			state.loginInfo = action.payload;
			state.error = null;
		},
		loginFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		userRegistrationRequest(state, action) {
			state.loading = true;
		},
		userRegistrationSuccess(state, action) {
			state.loading = false;
			state.user = action.payload;
			state.error = null;
		},
		userRegistrationFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		forgotRequest(state, action) {
			state.loading = true;
		},
		forgotSuccess(state, action) {
			state.loading = false;
			state.forgot = action.payload;
			state.error = null;
		},
		forgotFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		otpRequest(state, action) {
			state.loading = true;
		},
		otpSuccess(state, action) {
			state.loading = false;
			state.otp = action.payload;
			state.error = null;
		},
		otpFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		resetRequest(state, action) {
			state.loading = true;
		},
		resetSuccess(state, action) {
			state.loading = false;
			state.reset = action.payload;
			state.error = null;
		},
		resetFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		changepasswordRequest(state, action) {
			state.loading = true;
		},
		changepasswordSuccess(state, action) {
			state.loading = false;
			state.changepassword = action.payload;
			state.error = null;
		},
		changepasswordFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		leadRequest(state, action) {
			state.loading = true;
		},
		leadSuccess(state, action) {
			state.loading = false;
			state.lead = action.payload;
			state.error = null;
		},
		leadFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		custRequest(state, action) {
			state.loading = true;
		},
		custSuccess(state, action) {
			state.loading = false;
			state.cust = action.payload;
			state.error = null;
		},
		custFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		feedbackRequest(state, action) {
			state.loading = true;
		},
		feedbackSuccess(state, action) {
			state.loading = false;
			state.feedback = action.payload;
			state.error = null;
		},
		feedbackFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = HomeReducer;
const config = {
	headers: {
		'Content-Type': 'application/json',
	},
};
const config2 = {
	headers: {
		'Content-Type': 'multipart/form-data',
	},
};
export const {
	loginRequest,
	loginSuccess,
	loginFail,
	userRegistrationRequest,
	userRegistrationSuccess,
	userRegistrationFail,
	forgotRequest,
	forgotSuccess,
	forgotFail,
	otpRequest,
	otpSuccess,
	otpFail,
	resetRequest,
	resetSuccess,
	resetFail,
	changepasswordRequest,
	changepasswordSuccess,
	changepasswordFail,
	leadRequest,
	leadSuccess,
	leadFail,
	custRequest,
	custSuccess,
	custFail,
	feedbackRequest,
	feedbackSuccess,
	feedbackFail,
} = actions;

export const loginDispatch = (bodyData, navigate) => async (dispatch) => {
	try {
		dispatch(loginRequest());
		const { data } = await axiosInstance.post(
			'/loginpartner',
			bodyData,
			config
		);
		console.log('data', data);
		dispatch(loginSuccess(data));
		if (data) {
			navigate('/order');
		} else {
			alert('Failed');
		}
	} catch (error) {
		alert('Failed');
		dispatch(
			loginFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const userRegistrationDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(userRegistrationRequest());
		const { data } = await axiosInstance.post(
			'/registerpartner',
			bodyData,
			config2
		);
		console.log('data', data);
		dispatch(userRegistrationSuccess(data));
		if (data) {
			alert('Registration Success');
		}
	} catch (error) {
		alert('Registration Failed');
		dispatch(
			userRegistrationFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const forgotPasswordDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(forgotRequest());
		const { data } = await axiosInstance.post('/forgot', bodyData, config);
		console.log('data', data);
		dispatch(forgotSuccess(data));
	} catch (error) {
		dispatch(
			forgotFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const OtpVerifyDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(otpRequest());
		const { data } = await axiosInstance.post(
			'/otp_verification',
			bodyData,
			config
		);
		console.log('data', data);
		dispatch(otpSuccess(data));
	} catch (error) {
		dispatch(
			otpFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const resetPasswordDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(resetRequest());
		const { data } = await axiosInstance.post(
			'/reset_password',
			bodyData,
			config
		);
		console.log('data', data);
		dispatch(resetSuccess(data));
	} catch (error) {
		dispatch(
			resetFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const changePasswordDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(changepasswordRequest());
		const { data } = await axiosInstance.post(
			'/change_password',
			bodyData,
			config
		);
		console.log('data', data);
		dispatch(changepasswordSuccess(data));
	} catch (error) {
		dispatch(
			changepasswordFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const addLeadDispatch = (bodyData, navigate) => async (dispatch) => {
	try {
		dispatch(leadRequest());
		const { data } = await axiosInstance.post('/addlead', bodyData, config);
		console.log('data', data);
		dispatch(leadSuccess(data));
		if (data?.status === 'success') {
			alert('!! Thank you for Interest Our Team will Contact Shortly !!');
			navigate('/');
		} else {
			alert('Failed');
		}
	} catch (error) {
		alert('Failed');
		dispatch(
			leadFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const getCustomerIdDispatch = (id) => async (dispatch) => {
	try {
		dispatch(custRequest());
		const { data } = await axiosInstance.get(`/customers/${id}`, config);
		console.log('data', data);
		dispatch(custSuccess(data));
	} catch (error) {
		dispatch(
			custFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const addfeedbackDispatch = (bodyData, navigate) => async (dispatch) => {
	try {
		dispatch(feedbackRequest());
		const { data } = await axiosInstance.post('/addfeedback', bodyData, config);
		console.log('data', data);
		dispatch(feedbackSuccess(data));
		if (data?.status === 'success') {
			alert('!! Thank you for your valuable feedback!!');
			// navigate('/');
		}
	} catch (error) {
		// alert('Failed');
		dispatch(
			feedbackFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default HomeReducer;
